import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { validatePostalCode } from '../../validationUtils';
import { getAddress, getCurrentDate } from '../../utilities';
import { useAuth } from '../../context/AuthContext.js';
import LocationSelectorForForm from '../locaties/LocationSelectorForForm.js';
import '../student/Newstudent.css';
import IBANInput from '../../components/IBANInput.js';

function Newstudent() {
  const [postalcodeValidation, setPostalCodeValidation] = useState({ valid: true, message: '' });

  const [values, setValues] = useState({
    firstname: '',
    lastname: '',
    birthdate: '',
    datein: getCurrentDate(),
    dateout: '',
    street: '',
    housenr: '',
    postalcode: '',
    city: '',
    school: '',
    allergy: '',
    iban: '',
    accountowner: '',
    monthlyamount: '',
    comments: '',
    mailing: '',
    toestemmingfoto: '',
    location_id: null,
  });

  const [locations, setLocations] = useState([]);

  const navigate = useNavigate();
  const token = sessionStorage.getItem('jwtToken');
  const { userInfo } = useAuth();
  const userRole = userInfo?.role;

  useEffect(() => {
    if (userRole === 'super_admin') {
      axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/location/allLocations`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
        })
        .then((res) => {
          const locs = res.data.data || res.data;
          setLocations(Array.isArray(locs) ? locs : []);
        })
        .catch((err) => console.error('Error fetching locations', err));
    } else {
      setLocations([]);
    }
  }, [userRole, token]);

  const handleSubmit = (event) => {
    event.preventDefault();

    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/students/addstudent`, values, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.Status === 'Success') {
          navigate('/allstudents');
        } else {
          alert('Error: ' + res.data.status);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleCancel = () => {
    navigate('/allstudents');
  };

  return (
    <div>
      <div className="bg-white p-4">
        <div>
          <h2 className="text-center">Nieuwe leerling</h2>
        </div>

        <hr className="seperator" />
        <p className="text-center">Gegevens Leerling</p>

        <form onSubmit={handleSubmit} className="form-student">
          <LocationSelectorForForm
            userRole={userRole}
            value={values.location_id ?? ''}
            onChange={(e) =>
              setValues({
                ...values,
                location_id: e.target.value || null,
              })
            }
            locations={locations}
          />

          <div className="row">
            <div className="mb-3 col">
              <label htmlFor="firstname">
                Voornaam<span style={{ color: 'red' }}>*</span>
              </label>
              <input
                className="form-control rounded-0"
                type="text"
                name="firstname"
                placeholder="Voornaam"
                required
                onChange={(e) => setValues({ ...values, firstname: e.target.value })}
              />
            </div>

            <div className="mb-3 col">
              <label htmlFor="lastname">
                Achternaam<span style={{ color: 'red' }}>*</span>
              </label>
              <input
                className="form-control rounded-0"
                type="text"
                name="lastname"
                placeholder="Achternaam"
                required
                onChange={(e) => setValues({ ...values, lastname: e.target.value })}
              />
            </div>
          </div>

          <div className="row">
            <div className="mb-3 col">
              <label htmlFor="birthdate">
                Geboortedatum<span style={{ color: 'red' }}>*</span>
              </label>
              <input
                className="form-control rounded-0"
                type="date"
                name="birthdate"
                placeholder="Geboortedatum"
                required
                onChange={(e) => setValues({ ...values, birthdate: e.target.value })}
              />
            </div>

            <div className="mb-3 col">
              <label htmlFor="datein">
                Datum Inschrijving<span style={{ color: 'red' }}>*</span>
              </label>
              <input
                className="form-control rounded-0"
                type="date"
                name="datein"
                placeholder="Datum Inschrijving"
                required
                value={values.datein}
                onChange={(e) => setValues({ ...values, datein: e.target.value })}
              />
            </div>
          </div>

          <div className="row">
            <div className="mb-3 col">
              <label htmlFor="postalcode">Postcode</label>
              <input
                className={`form-control rounded-0 ${postalcodeValidation.valid ? '' : 'is-invalid'}`}
                type="text"
                name="postalcode"
                placeholder="Postcode"
                value={values.postalcode}
                onChange={(e) => {
                  setValues({ ...values, postalcode: e.target.value });
                  validatePostalCode(e.target.value);
                }}
                onBlur={(e) => {
                  const isValid = validatePostalCode(e.target.value);
                  if (!isValid) {
                    setPostalCodeValidation({ valid: false, message: 'Ongeldige Postcode' });
                  } else {
                    setPostalCodeValidation({ valid: true, message: '' });
                  }
                }}
              />
              {postalcodeValidation.valid ? null : (
                <div className="invalid-feedback">{postalcodeValidation.message}</div>
              )}
            </div>

            <div className="mb-3 col">
              <label htmlFor="housenr">Huisnummer</label>
              <input
                className="form-control rounded-0"
                type="text"
                name="housenr"
                placeholder="Huisnummer"
                onChange={(e) => setValues({ ...values, housenr: e.target.value })}
                onBlur={() => getAddress(values, setValues, postalcodeValidation)}
              />
            </div>
          </div>

          <div className="row">
            <div className="mb-3 col">
              <label htmlFor="street">Straat</label>
              <input
                className="form-control rounded-0"
                type="text"
                name="street"
                placeholder="Straat"
                readOnly
                value={values.street}
                onChange={(e) => setValues({ ...values, street: e.target.value ?? '' })}
                style={{ backgroundColor: '#FAFAFA' }}
              />
            </div>

            <div className="mb-3 col">
              <label htmlFor="city">Plaats</label>
              <input
                className="form-control rounded-0"
                type="text"
                name="city"
                placeholder="Plaats"
                readOnly
                value={values.city}
                onChange={(e) => setValues({ ...values, city: e.target.value ?? '' })}
                style={{ backgroundColor: '#FAFAFA' }}
              />
            </div>
          </div>

          <div className="row">
            <div className="mb-3 col">
              <label htmlFor="school">School</label>
              <input
                className="form-control rounded-0"
                type="text"
                name="school"
                placeholder="School"
                onChange={(e) => setValues({ ...values, school: e.target.value })}
              />
            </div>

            <div className="mb-3 col">
              <label htmlFor="allergy">Allergie</label>
              <input
                className="form-control rounded-0"
                type="text"
                name="allergy"
                placeholder="Allergie"
                onChange={(e) => setValues({ ...values, allergy: e.target.value })}
              />
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="comments">Opmerkingen</label>
            <textarea
              className="form-control rounded-0"
              rows="5"
              cols="50"
              name="comments"
              placeholder="Opmerkingen"
              onChange={(e) => setValues({ ...values, comments: e.target.value })}
            />
          </div>

          <hr className="seperator" />

          <div className="row">
            <IBANInput
              value={values.iban}
              onChange={(iban) => setValues((v) => ({ ...v, iban }))}
            />

            <div className="mb-3 col">
              <label htmlFor="accountowner">Rekeninghouder</label>
              <input
                className="form-control rounded-0"
                type="text"
                name="accountowner"
                placeholder="Rekeninghouder"
                onChange={(e) => setValues({ ...values, accountowner: e.target.value })}
              />
            </div>

            <div className="mb-3 col">
              <label htmlFor="monthlyamount">Maandbedrag</label>
              <input
                className="form-control rounded-0"
                type="text"
                name="monthlyamount"
                placeholder="Maandbedrag"
                onChange={(e) => setValues({ ...values, monthlyamount: e.target.value })}
              />
            </div>
          </div>

          <hr className="seperator" />
          <hr className="seperator" />
          <p className="text-center font-italic">AVG</p>
          <hr className="seperator" />

          <div className="row">
            <div className="mb-3 col">
              <label htmlFor="mailing">Toestemming Nieuwsbrief</label>
              <div>
                <select
                  name="mailing"
                  onChange={(e) => setValues({ ...values, mailing: e.target.value })}
                >
                  <option value="">Maak een keuze</option>
                  <option value="ja">Ja</option>
                  <option value="nee">Nee</option>
                </select>
              </div>
            </div>

            <div className="mb-3 col">
              <label htmlFor="toestemmingfoto">Toestemming Foto's</label>
              <div>
                <select
                  name="toestemmingfoto"
                  onChange={(e) =>
                    setValues({ ...values, toestemmingfoto: e.target.value })
                  }
                >
                  <option value="">Maak een keuze</option>
                  <option value="ja">Ja</option>
                  <option value="nee">Nee</option>
                </select>
              </div>
            </div>
          </div>

          <hr className="seperator" />

          <div className="row">
            <div className="col-md-6">
              <button
                type="button"
                className="btn btn-secondary w-100 rounded-0"
                onClick={handleCancel}
              >
                Annuleren
              </button>
            </div>

            <div className="col-md-6">
              <button type="submit" className="btn btn-secondary w-100 rounded-0">
                Opslaan
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Newstudent;